import type { ReactNode } from 'react';

/** CSS chooses the first-paint mode on the server and client at the same breakpoint.
 * display:none also removes the inactive navigation from focus and accessibility trees.
 * A persisted preference retains the existing explicit override at every desktop width.
 * The dashboard seeds the saved preference in its server-rendered payload.
 * A timed-out preference read falls back here and may resize on client recovery.
 */
export function ResponsiveSidebar({
  preference,
  rail,
  expanded,
}: {
  preference: boolean | null | undefined;
  rail: ReactNode;
  expanded: ReactNode;
}) {
  const frame = 'shrink-0 self-start lg:sticky lg:top-0 lg:h-svh lg:max-h-svh';
  return (
    <>
      <div
        data-sidebar-mode="rail"
        className={`${frame} ${preference === false ? 'hidden' : preference === true ? 'hidden lg:flex' : 'hidden lg:flex xl:hidden'}`}
      >
        {rail}
      </div>
      <div
        data-sidebar-mode="expanded"
        className={`${frame} ${preference === true ? 'hidden' : preference === false ? 'hidden lg:flex' : 'hidden xl:flex'}`}
      >
        {expanded}
      </div>
    </>
  );
}
